interface ServicesSectionProps {
  onConsultClick: () => void;
}

const ServicesSection = ({ onConsultClick }: ServicesSectionProps) => {
  const services = [
    {
      icon: 'ri-robot-line',
      title: '業務自動化・AI活用支援',
      description: 'Google Apps Script・Excel VBA・AIエージェントを活用した業務効率化。繰り返し作業の自動化で工数を大幅削減します。',
      features: ['データ処理自動化', 'レポート自動生成', 'AI連携システム', 'ワークフロー最適化']
    },
    {
      icon: 'ri-global-line',
      title: 'ホームページ制作',
      description: 'ビジネスの成長を支える効果的なWebサイトを制作。SEO対策・レスポンシブデザイン・CMS導入まで対応します。',
      features: ['レスポンシブデザイン', 'SEO最適化', 'CMS導入', 'アクセス解析設定']
    },
    {
      icon: 'ri-map-pin-line',
      title: 'MEO対策・Googleビジネス最適化',
      description: 'Googleマップでの上位表示を実現。地域密着型ビジネスの集客力向上をサポートします。',
      features: ['Googleビジネス最適化', '口コミ管理', '地域SEO対策', '競合分析']
    },
    {
      icon: 'ri-computer-line',
      title: 'DX支援・デジタル化移行',
      description: '紙ベースの業務からデジタル化への移行をサポート。業務プロセス全体の効率化を実現します。',
      features: ['業務プロセス分析', 'システム選定支援', 'データ移行', '運用サポート']
    },
    {
      icon: 'ri-microsoft-line',
      title: 'Microsoft / Googleツール移行',
      description: 'Office 365・Google Workspaceの導入・移行をサポート。既存データの移行から運用まで一貫対応。',
      features: ['ツール選定コンサル', 'データ移行支援', '操作研修', '運用最適化']
    },
    {
      icon: 'ri-line-chart-line',
      title: 'ITコンサルティング',
      description: 'IT戦略の立案から実行まで包括的にサポート。中小企業のIT活用を総合的に支援します。',
      features: ['IT戦略立案', 'システム選定', '導入支援', '継続サポート']
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            提供<span className="text-blue-600">サービス</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            業務効率化からWebサイト制作、DX支援まで、ビジネスの成長を包括的にサポートします
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-gray-700 text-sm">
                    <i className="ri-check-line text-green-600 mr-3"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">
              どのサービスが最適かわからない方も、お気軽にご相談ください
            </h3>
            <p className="text-blue-100 mb-6">
              現在の課題やご要望をお聞かせいただければ、最適なソリューションをご提案いたします。
            </p>
            <button 
              onClick={onConsultClick}
              className="bg-white text-blue-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              サービス相談をする
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;